<template>
  <div class="checkout-step-wrapper">
    <div class="container-fluid">
      <div class="row">
        <ol class="checkout-step-list">
          <li class="checkout-step" :class="{'checkout-step--active': stepIndex < 4}">Your Holiday</li>
          <li class="checkout-step" :class="{'checkout-step--active': stepIndex === 4}">Your Details</li>
          <li class="checkout-step" :class="{'checkout-step--active': stepIndex > 4}">Payment</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: mapState('checkout', ['stepIndex'])
};
</script>